export default __webpack_public_path__ + "static/media/prooctane-utility-can.988b46c5.glb";